import { createUseStyles } from 'react-jss';
import { Transitions } from '@picsart/rc/enums';
import { canHover } from '@picsart/rc/helpers';

import { ITheme } from 'types';

const useStyles = createUseStyles((theme: ITheme) => ({
  root: {
    display: 'inline-block',
    width: 36,
    height: 36,
    border: 'none',
    outline: 'none',
    borderRadius: 'inherit',
    cursor: 'pointer',

    [canHover()]: {
      '&:hover': {
        '& path': {
          fill: theme.colors.texts.base,
        },
      },
    },
    [canHover(false)]: {
      '&:active': {
        '& path': {
          fill: theme.colors.texts.base,
        },
      },
    },
  },
  icon: {
    display: 'inline-block',
    verticalAlign: 'middle',
    width: 20,
    height: 20,

    '& path': {
      fill: theme.colors.texts.tint1,
      transition: `fill ${Transitions.Default} ease-in-out`,
    },
  },
}));

export default useStyles;
